import { z } from 'zod'

import { EnumBuilder } from '@mntn-dev/utility-types'
import { ModelFilterSchema } from '../model-filter-schema.ts'
import { NoteSchema } from './property.models.ts'
import {
  DeliverableIdSchema,
  FileIdSchema,
  ProofIdSchema,
  RoundIdSchema,
} from './unique-id.models.ts'

/**
 * ProofStatus
 */
export const [ProofStatuses, ProofStatusSchema, ProofStatusEnum] = EnumBuilder(
  'approved',
  'changes_requested'
)
export type ProofStatus = z.infer<typeof ProofStatusSchema>

/**
 * Proof Proposal
 */
export const ProofProposalSchema = z.object({ notes: NoteSchema }).partial()

export type ProofProposal = z.infer<typeof ProofProposalSchema>

/**
 * Proof Feedback
 */
export const ProofFeedbackSchema = z.object({ notes: NoteSchema }).partial()

export type ProofFeedback = z.infer<typeof ProofFeedbackSchema>

/**
 * ProofDomainSelectModel
 */
export const ProofDomainSelectModelSchema = z.object({
  proofId: ProofIdSchema,
  roundId: RoundIdSchema,
  proposal: ProofProposalSchema,
  feedback: ProofFeedbackSchema,
  deliverableId: DeliverableIdSchema,
  fileId: FileIdSchema.optional(),
  status: ProofStatusSchema.optional(),
})

export type ProofDomainSelectModel = z.infer<
  typeof ProofDomainSelectModelSchema
>

/**
 * ProofDomainInsertModel
 */
export const ProofDomainInsertModelSchema = ProofDomainSelectModelSchema.omit({
  proposal: true,
  feedback: true,
}).partial({
  proofId: true,
})

export type ProofDomainInsertModel = z.infer<
  typeof ProofDomainInsertModelSchema
>

/**
 * ProofDomainUpdateModel
 */
export const ProofDomainUpdateModelSchema = z
  .object({
    status: ProofStatusSchema.nullable(),
    fileId: FileIdSchema.nullable(),
    proposal: ProofProposalSchema.merge(
      z.object({ notes: NoteSchema.nullable() }).partial()
    ),
    feedback: ProofProposalSchema.merge(
      z.object({ notes: NoteSchema.nullable() }).partial()
    ),
  })
  .partial()

export type ProofDomainUpdateModel = z.infer<
  typeof ProofDomainUpdateModelSchema
>

/**
 * ProofDomainSelectModelFilters
 */
export const ProofDomainSelectModelFiltersSchema = z
  .object({
    proofId: ModelFilterSchema(ProofIdSchema),
    roundId: ModelFilterSchema(RoundIdSchema),
    deliverableId: ModelFilterSchema(DeliverableIdSchema),
    fileId: ModelFilterSchema(FileIdSchema),
    status: ModelFilterSchema(ProofStatusSchema),
  })
  .partial()

export type ProofDomainSelectModelFilters = z.infer<
  typeof ProofDomainSelectModelFiltersSchema
>
